import { render, staticRenderFns } from "./customerHome.vue?vue&type=template&id=28977ddc&scoped=true&"
import script from "./customerHome.vue?vue&type=script&lang=js&"
export * from "./customerHome.vue?vue&type=script&lang=js&"
import style0 from "./customerHome.vue?vue&type=style&index=0&id=28977ddc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28977ddc",
  null
  
)

export default component.exports